import {
	requestByID,
	requestCreate,
	requestDestroy,
	requestUpdate,
	requestsList,
	statusByID,
	statusCreate,
	statusDestroy,
	statusList,
	statusUpdate,
} from '@/services/agency/keys-requests-status.service'

export default {
	namespaced: true,
	state: {
		// Keys STATUS
		statusList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		status: {},

		// STATUS Keys STATUS
		statusestatus: 'pending',
		statusesaveStatus: 'init',
		statusDeleteStatus: 'init',

		// Keys REQUESTS
		requestsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		request: {},

		// STATUS Keys REQUESTS
		requestsStatus: 'pending',
		requestsSaveStatus: 'init',
		requestsDeleteStatus: 'init',
	},
	getters: {
		// Keys STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// Keys STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// Keys STATUS
		getStatusDeleteStatus(state) {
			return state.statusDeleteStatus
		},
		getStatusesaveStatus(state) {
			return state.statusesaveStatus
		},
		getStatusestatus(state) {
			return state.statusestatus
		},

		// Requests Keys
		getRequestsList(state) {
			return state.requestsList
		},
		getRequest(state) {
			return state.request
		},

		// Keys REQUESTS
		getRequestsDeleteStatus(state) {
			return state.requestsDeleteStatus
		},
		getRequestsSaveStatus(state) {
			return state.requestsSaveStatus
		},
		getRequestsStatus(state) {
			return state.requestsStatus
		},
	},
	mutations: {
		// Keys STATUS
		STATUS_LIST(state, value) {
			state.statusList = value
		},
		SET_STATUS(state, value) {
			state.status = value
		},

		// STATUS Keys STATUS
		STATUS_STATUS(state, value) {
			state.statusestatus = value
		},
		STATUS_SAVE_STATUS(state, value) {
			state.statusesaveStatus = value
		},
		STATUS_DELETE_STATUS(state, value) {
			state.statusDeleteStatus = value
		},

		// Keys REQUESTS
		REQUESTS_LIST(state, value) {
			state.requestsList = value
		},
		SET_REQUEST(state, value) {
			state.request = value
		},

		// STATUS Keys REQUESTS
		REQUESTS_STATUS(state, value) {
			state.requestsStatus = value
		},
		REQUEST_SAVE_STATUS(state, value) {
			state.requestsSaveStatus = value
		},
		REQUEST_DELETE_STATUS(state, value) {
			state.requestsDeleteStatus = value
		},
	},
	actions: {
		// Keys Status
		async fetchStatusList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('STATUS_STATUS', 'pending')
			commit('STATUS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await statusList(params)
				commit('STATUS_STATUS', 'init')
				commit('STATUS_LIST', data)
				return data
			} catch (error) {
				commit('STATUS_STATUS', 'init')
				throw error
			}
		},
		async fetchStatusByID({ commit }, params) {
			commit('STATUS_STATUS', 'pending')
			try {
				const { data } = await statusByID(params)
				commit('STATUS_STATUS', 'init')
				commit('SET_STATUS', data.data)
				return data
			} catch (error) {
				commit('STATUS_STATUS', 'init')

				return error
			}
		},
		async saveNewStatus({ commit }, params) {
			commit('STATUS_SAVE_STATUS', 'pending')
			try {
				const { data } = await statusCreate(params)
				commit('STATUS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STATUS_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateStatus({ commit }, params) {
			commit('STATUS_SAVE_STATUS', 'pending')
			try {
				const { data } = await statusUpdate(params)
				commit('STATUS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STATUS_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteStatusByID({ commit }, params) {
			commit('STATUS_DELETE_STATUS', 'pending')
			try {
				const { data } = await statusDestroy(params)
				commit('STATUS_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STATUS_DELETE_STATUS', 'error')

				return error
			}
		},

		// Keys Requests
		async fetchRequestList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('REQUESTS_STATUS', 'pending')
			commit('REQUESTS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await requestsList(params)
				commit('REQUESTS_STATUS', 'init')
				commit('REQUESTS_LIST', data)
				return data
			} catch (error) {
				commit('REQUESTS_STATUS', 'init')
				throw error
			}
		},
		async fetchRequestByID({ commit }, params) {
			commit('REQUESTS_STATUS', 'pending')
			try {
				const { data } = await requestByID(params)
				commit('REQUESTS_STATUS', 'init')
				commit('SET_REQUEST', data.data)
				return data
			} catch (error) {
				commit('REQUESTS_STATUS', 'init')

				return error
			}
		},
		async saveNewRequest({ commit }, params) {
			commit('REQUEST_SAVE_STATUS', 'pending')
			try {
				const { data } = await requestCreate(params)
				commit('REQUEST_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REQUEST_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateRequest({ commit }, params) {
			commit('REQUEST_SAVE_STATUS', 'pending')
			try {
				const { data } = await requestUpdate(params)
				commit('REQUEST_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REQUEST_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteRequestByID({ commit }, params) {
			commit('REQUEST_DELETE_STATUS', 'pending')
			try {
				const { data } = await requestDestroy(params)
				commit('REQUEST_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REQUEST_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
